//
//
//
//
//
//
//
//
//
//
//
//

import OriginStoryTabletUpView from './OriginStoryTabletUpView.vue';
import OriginStoryMobileView from './OriginStoryMobileView.vue';

export default {
  name: 'OriginStory',
  components: {
    OriginStoryMobileView,
    OriginStoryTabletUpView,
  },
  computed: {
    originStoryList() {
      return [
        {
          src: 'v4/fc-about-us-khalil-boxing-001.png',
          alt: 'Khalil boxing opponent',
          title: 'Our founder and ceo, khalil zahar began boxing training in 2010.',
          text: 'He fell in love with the sport and how the training worked both your body and mind. After his first year, he felt his boxing skills begin to plateau. Frustrated, Khalil had no way of knowing if he was improving.',
        },
        {
          src: 'v4/fc-about-us-equipment-diagram-001.png',
          alt: 'tracker and boxing bag diagram',
          title: 'and from that, an idea sparked.',
          text: 'When no one in the boxing community knew of a product that could provide data on his workouts, he started to think. As a graduate student studying microelectromechanical systems, he knew sensor technology was just starting to become small enough to put on your body without getting in the way.',
        },
        {
          src: 'v4/fc-about-us-founders-001.png',
          alt: 'group of the FightCamp founders',
          title: 'Almost every professional fighter was using our technology.',
          text: 'Khalil teamed up with five co-founders (Alexandre Marcotte St-Michel, Alexandre Lapointe, Jerome Soucy Rousseau, Patrick Chandler, Tommy Duquette). They developed punch trackers with advanced punch recognition, and moved quickly to research & improve the punch trackers until ',
        },
        {
          src: 'v4/fc-about-us-shanie-boxing-001.png',
          alt: 'Shanie in FightCamp boxing ring',
          title: 'And thus, fightcamp was born!',
          text: 'We planted our flag in the athletic realm, but we want to keep pushing the boundaries. Boxing is one of the few sports where the majority of people who train are not actual fighters. We see an opportunity to take a traditional boxing gym experience and expand it to the world.”',
        },
      ];
    },
  },
};
